import React, { useState } from 'react';

const ContactForm = () => {
  const containerStyle = {
    minHeight: '100vh',
    backgroundColor: 'black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
  };

  const formBoxStyle = {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '2rem',
    width: '100%',
    maxWidth: '1100px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
  };

  const headingStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: 'black',
    textAlign: 'center',
    marginBottom: '1.5rem',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: '500',
    color: 'black',
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    marginBottom: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontSize: '1rem',
    outline: 'none',
  };

  const textareaStyle = {
    ...inputStyle,
    height: '300px',
    resize: 'vertical',
  };

  const buttonStyle = {
    width: '100%',
    backgroundColor: '#169893',
    color: 'white',
    padding: '0.75rem',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background 0.3s',
  };

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      const response = await fetch('https://api.ismailishq.com/dashboard/sendemail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          FromEmailAddress: email,
          Name: name,
          Body: body,
        }),
      });
      if (response.ok) {
        setResult({ success: true, message: 'Message sent successfully!' });
        setName('');
        setEmail('');
        setBody('');
      } else {
        setResult({ success: false, message: 'Failed to send message.' });
      }
    } catch (err) {
      setResult({ success: false, message: 'Error sending message.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={formBoxStyle}>
      <h2 style={headingStyle}>Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <label style={labelStyle}>Name</label>
        <input type="text" placeholder="Your full name" style={inputStyle} value={name} onChange={e => setName(e.target.value)} required />

        <label style={labelStyle}>Email</label>
        <input type="email" placeholder="you@example.com" style={inputStyle} value={email} onChange={e => setEmail(e.target.value)} required />

        <label style={labelStyle}>Message</label>
        <textarea placeholder="Your message..." style={textareaStyle} value={body} onChange={e => setBody(e.target.value)} required></textarea>

        <button type="submit" style={buttonStyle} disabled={loading}>{loading ? 'Sending...' : 'Send Message'}</button>
        {result && (
          <div style={{
            marginTop: '1rem',
            color: result.success ? 'green' : 'red',
            fontWeight: 'bold',
            textAlign: 'center',
          }}>{result.message}</div>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
